import { Box, Flex, GridItem, Image, Skeleton, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

import { RanaButton } from "@nens/ranalib";

export const SMALL_TILE_CARD_HEIGHT = 44;
const SMALL_TILE_CARD_IMAGE_HEIGHT = 24;

const ALIGN_ITEMS = { left: "flex-start", center: "center" } as const;

type SmallTileCardProps = {
  title: ReactNode;
  description?: ReactNode;
  color?: string;
  imageSrc?: string;
  imageAlt: string;
  isImageLoading?: boolean;
  textAlign?: "left" | "center";
  onClick: () => void;
};

const TileImage = ({ src, alt, isLoading }: { src?: string; alt: string; isLoading?: boolean }) => {
  const sharedProps = {
    w: "full",
    h: SMALL_TILE_CARD_IMAGE_HEIGHT,
    flexShrink: 0,
    rounded: "base",
  } as const;

  if (isLoading) return <Skeleton {...sharedProps} />;
  if (!src) return <Box {...sharedProps} bg="brand.grey.300" />;
  return <Image {...sharedProps} src={src} objectFit="cover" alt={alt} />;
};

export const SmallTileCard = ({
  title,
  description,
  color,
  imageSrc,
  imageAlt,
  isImageLoading,
  textAlign = "left",
  onClick,
}: SmallTileCardProps) => {
  return (
    <GridItem position="relative" h={SMALL_TILE_CARD_HEIGHT}>
      <RanaButton variant="listitem" h="full" w="full" onClick={onClick}>
        <Flex w="full" h="full" flexDir="column">
          <TileImage src={imageSrc} alt={imageAlt} isLoading={isImageLoading} />
          <Flex
            w="full"
            h="full"
            flexGrow={1}
            flexDir="column"
            alignItems={ALIGN_ITEMS[textAlign]}
            justifyContent="center"
            textAlign={textAlign}
            px={2}
            overflow="hidden"
            color={color}
          >
            <Box w="full">{title}</Box>
            {description && (
              <Text mt={2} fontSize="sm" fontWeight="normal">
                {description}
              </Text>
            )}
          </Flex>
        </Flex>
      </RanaButton>
    </GridItem>
  );
};
